import React from "react";

// Libraries
import { Container } from "@hybris-software/ui-kit";

// Styles
import Style from "./HeroSection.module.css";

const HeroSection = () => {
  return (
    <div className={Style.heroSection}>
      <div className={Style.heroContainer}>
        <Container className={Style.heroContent}>
          <h1>Contattaci</h1>
          <p className={Style.subTitle}>
           I nostri Professionisti sono a tua disposizione
          </p>
        </Container>
      </div>
    </div>
  );
};

export default HeroSection;
